export default {
    carbonCredit: {
        view: 'Tazama',
        edit: 'Hariri',
        back: 'Rudi',
        preview: 'Hakiki',
        confirm: 'Thibitisha',
        cancel: 'Ghairi',
        dashboard: 'Dashibodi',
        select: 'Chagua',
        submit: 'Wasilisha',
        save: 'Hifadhi',
        title: 'Mikopo ya Kaboni',
        projects: 'Miradi',
        carbonProjectCredits: 'Mikopo ya Miradi ya Kaboni',
        carbonCreditProjects: 'Miradi ya Mikopo ya Kaboni',
        exportAs: 'Hamisha kama',
        downloadAsCSV: 'Pakua kama CSV',
        downloadAsExcel: 'Pakua kama Excel',
        downloadAsPDF: 'Pakua kama PDF',
        registerNewProject: 'Sajili Mradi Mpya',
        creditInfo: '*Hii ni idadi ya takriban ya mikopo. Idadi halisi ya mikopo inaweza kuwa tofauti baada ya uthibitisho.',
        search: 'Tafuta',
        projectTitle: 'Jina la Mradi',
        projectType: 'Aina ya Mradi',
        country: 'Nchi',
        totalCreditsGenerated: 'Jumla ya Mikopo Iliyozalishwa',
        status: 'Hali',
        descriptionPlaceholder: "Tafadhali toa maelezo ya mradi pamoja na malengo",
        filePreviewNotAvailable: 'Hakiki ya faili haipatikani kwa aina hii ya faili',
        active: 'Inayofanya kazi',
        inactive: 'Isiyofanya kazi',
        pending: 'Inasubiri',
        proposed: 'Iliyopendekezwa',
        planned: 'Iliyopangwa',
        inProgress: 'Inaendelea',
        operational: 'Inayofanya kazi',
        deactivated: 'Iliyokatwa',
        avoidedDeforestation: 'Ukataji wa Misitu Uliozuiliwa',
        agroForestry: 'Kilimo cha Misitu',
        forestry: 'Uasiliaji',
        regenerativeAgriculture: 'Kilimo cha Kurejesha',
        agroforestry: 'Kilimo cha Misitu',
        regenerative_agriculture: 'Kilimo cha Kurejesha',
        projectDeletedSuccessfully: 'Mradi ulikatwa kwa mafanikio',
        projectUpdatedSuccessfully: 'Mradi ulisasishwa kwa mafanikio',
        projectRegisteredSuccessfully: 'Mradi ulisajiliwa kwa mafanikio',
        deactivateProjectError: 'Hitilafu katika kukata mradi',
        deactivate: 'Kata',
        deactivateProject: 'Kata Mradi',
        deactivateConfirmation: 'Una uhakika unataka kukata mradi huu?',
        registerProject: 'Sajili Mradi Mpya',
        editProject: 'Hariri Mradi',

        register: { 
            title: 'Sajili Mradi',
            editTitle: 'Hariri Mradi',
            projectTitle: 'Jina la Mradi',
            projectType: 'Aina ya Mradi',
            description: 'Maelezo',
            selectCountry: "Chagua Nchi",
            selectOrganization: 'Chagua Mashirika',
            status: 'Hali',
            creditType: 'Aina ya Mikopo',
            creditStart: 'Mwanzo wa Mikopo',
            creditEnd: 'Mwisho wa Mikopo',
            standardMethodology: 'Kiwango/Mbinu',
            validationDocumentation: 'Nyaraka za Uthibitisho',
            vintage: 'Mvinyo',
            currency: 'Sarafu',
            projectInfo: 'Maelezo ya Mradi',
            organizationDetails: 'Maelezo ya Mashirika',
            attachmentTitle: 'Kiambatisho',
            attachmentInfo: 'Unaweza kuongeza nyaraka zozote za ziada, picha, video na faili za sauti zinazohusiana na mradi',
            documentation: 'Nyaraka',
            sdgsTitle: 'Malengo ya Maendeleo Endelevu (SDGs)',
            sdgsInfo: 'Tafadhali chagua malengo tu yanayohusiana na mradi huu maalum. Mashirika yatakuwa na uwezo wa kuona malengo tu yanayounganishwa na mradi huu.',
            dataCollectionTitle: 'Mzunguko wa Ukusanyaji wa Data',
            dataCollectionInfo: 'Ili kushiriki katika Programu ya Mikopo ya Kaboni, wakulima wanapaswa kutoa data ya kihistoria ya shamba wakati wa kujisajili na kuendelea kuwasilisha sasisho za data za mara kwa mara mradi programu inabaki kuwa hai. Hii inahakikisha ufuatiliaji sahihi wa utendaji wa kaboni kwa muda.',
            vintageYear: 'Mwaka wa Mvinyo',
            estimatedCredit: 'Mikopo ya Makadirio',
            pricePerCredit: 'Bei Kwa Mikopo',
            moduleName: 'Jina la Moduli',
            futureData: 'Ukusanyaji wa Data wa Baadaye wa Mara kwa Mara',
            score: 'Alama',
            approval: 'Idhini',

            projectAgreement: 'Makubaliano ya Mradi',
            headerImage: 'Picha ya Kichwa',
            headerImageInfo: '(Ukubwa wa picha ya kichwa 1920 x 420 pixel. Picha ya chaguo-msingi itabadilishwa na picha mpya unayopakia)',
            headerImagePlaceholder: "Picha ya Kichwa ya Chaguo-msingi",
            responsibleDimitraOffice: 'Ofisi ya Dimitra Inayohusika',
            selectDimitraOffice: 'Chagua Ofisi ya Dimitra',
            makeASelection: 'Fanya Uchaguzi',
            addNewDimitraOffice: 'Ongeza Ofisi Mpya ya Dimitra',
            editDimitraOffice: 'Hariri Ofisi ya Dimitra',
            officeName: 'Jina la Ofisi',
            contactPerson: 'Jina la Mtu wa Mawasiliano',
            phoneNumber: 'Nambari ya Simu',
            email: 'Barua pepe',
            address: 'Anwani',
            officeNameRequired: 'Jina la ofisi linahitajika',
            contactPersonRequired: 'Jina la mtu wa mawasiliano linahitajika',
            addressRequired: 'Anwani inahitajika',
            phoneNumberRequired: 'Nambari ya simu inahitajika',
            phoneNumberInvalid: 'Nambari ya simu si sahihi',
            phoneNumberLength: 'Nambari ya simu lazima iwe na tarakimu angalau 10',
            selectVintage: 'Chagua Mvinyo',
            officeAddedSuccessfully: 'Ofisi ya Dimitra iliongezwa kwa mafanikio',
            errorAddingOffice: 'Hitilafu katika kuongeza ofisi ya Dimitra',
            searchOrganizations: 'Tafuta Mashirika',
            searchOrganizationsPlaceholder: 'Tafuta kwa jina la shirika...',
            noOrganizationsFound: 'Hakuna mashirika yaliyopatikana',
            loadingOrganizations: 'Inapakia mashirika...',
            selectedOrganizations: 'Mashirika Yaliyochaguliwa',
            errorNegative: 'haiwezi kuwa hasi.',
            errorRequiredField: '{field} inahitajika.',
            errorOrganizationRequired: 'Shirika angalau moja lazima lichaguliwe.',
            errorVintageRequired: 'Ingizo angalau moja la mvinyo linahitajika.',
            errorVintageFieldsRequired: 'Sehemu zote za mvinyo (mwaka, mikopo, bei) zinahitajika.',
            allOrganizations: 'Mashirika Yote',
            removal: 'Kuondolewa',
            avoided: 'Iliyozuiliwa',
            mandatory: 'Lazima',
            scoreValidationError: 'Alama si sahihi kwa moduli "{module}". Alama lazima iwe nambari kamili 0 au zaidi.',
            approvalValidationError: 'Idhini si sahihi kwa moduli "{module}". Idhini lazima iwe nambari kamili kati ya 0 na 100.',
            saveError: 'Kuhifadhi mradi kushindwa',
            fileUploadFailed: 'Kupakia Faili Kushindwa',
            unsupportedFileFormat: 'Muundo wa faili usioendeshwa',
            errorUploadingFile: 'Hitilafu katika kupakia faili',
            scoreError: {
                invalid: 'Alama lazima iwe nambari sahihi',
                range: 'Alama lazima iwe 0 au zaidi',
                wholeNumber: 'Alama lazima iwe nambari kamili'
            },
            approvalError: {
                invalid: 'Idhini lazima iwe nambari sahihi',
                range: 'Idhini lazima iwe kati ya 0 na 100',
                wholeNumber: 'Idhini lazima iwe nambari kamili'
            },
            selectStatus: 'Chagua Hali',
            selectCreditType: 'Chagua Aina ya Mikopo',
            dateFormat: 'dd/mm/yyyy',
            standardPlaceholder: 'Kiwango',
            browse: 'Tafuta',
            currencyPlaceholder: 'USD',
            selectFile: 'Chagua Faili',
            dragDropFiles: 'Buruta na uangushe faili hapa',
            hideDetails: 'Ficha Maelezo',
            viewDetails: 'Tazama Maelezo',
            website: 'Tovuti',
            month: 'Mwezi(zi)',
            year: 'Mwaka',
        },

        error: 'Hitilafu',
        success: 'Mafanikio',
        remove: 'Ondoa',

        projectInfo: {
            title: 'Maelezo ya Mradi',
            organizationDetail: 'Maelezo ya Shirika',
            subOrganizations: 'Mashirika ya Chini',
            search: 'Tafuta',
            organizations: 'Mashirika',
            users: 'Watumiaji',
            registrationDate: 'Tarehe ya Usajili',
            close: 'Funga',
            country: 'Nchi',
            organizationsAddress: 'Anwani ya Mashirika',
            blockchainAddress: 'Anwani ya Blockchain',
            creditType: 'Aina ya Mikopo',
            projectType: 'Aina ya Mradi',
            officeName: 'Jina la Ofisi',
            contactPersonName: 'Jina la Mtu wa Mawasiliano',
            contactNumber: 'Nambari ya Mawasiliano',
            email: 'Barua pepe',
            address: 'Anwani',
            website: 'Tovuti',
            companyName: 'Jina la Kampuni',
            companyAddress: 'Anwani ya Kampuni',
            web: 'Tovuti',
            vintageYear: 'Mwaka wa Mvinyo',
            estimatedCredits: 'Mikopo ya Makadirio',
            pricePerCredit: 'Bei Kwa Mikopo',
            module: 'Moduli',
            recurring: 'Ya mara kwa mara',
            score: 'Alama',
            approval: 'Idhini',
            responsibleDimitraOffice: 'Ofisi ya Dimitra Inayohusika',
            status: 'Hali',
            standardMethodology: 'Kiwango/Mbinu',
            validationDocumentation: 'Nyaraka za Uthibitisho',
            creditStart: 'Mwanzo wa Mikopo',
            creditEnd: 'Mwisho wa Mikopo',
            attachmentTitle: 'Kiambatisho',
            sdgsTitle: 'Malengo ya Maendeleo Endelevu (SDGs)',
            dataCollectionTitle: 'Mzunguko wa Ukusanyaji wa Data',
            dataCollectionInfo: 'Ili kushiriki katika Programu ya Mikopo ya Kaboni, wakulima wanapaswa kutoa data ya kihistoria ya shamba wakati wa kujisajili na kuendelea kuwasilisha sasisho za data za mara kwa mara mradi programu inabaki kuwa hai. Hii inahakikisha ufuatiliaji sahihi wa utendaji wa kaboni kwa muda.',
            vintage: 'Mvinyo',
            moduleName: 'Jina la Moduli',
            futureData: 'Ukusanyaji wa Data wa Baadaye wa Mara kwa Mara',
            estimatedCredit: 'Mikopo ya Makadirio',
        },

        user: {
            title: 'Mtumiaji(wa) wa Mikopo ya Kaboni',
            selectOrganization: 'Chagua Shirika',
            selectProject: 'Chagua Mradi',
            allUsers: 'Watumiaji Wote',
            activeUsers: 'Watumiaji Wanaofanya Kazi',
            deactivatedUsers: 'Watumiaji Waliokatwa',
            pendingUsers: 'Watumiaji Wanasubiri',
            search: 'Tafuta',
            farmerName: 'Jina la Mkulima',
            farmName: 'Jina la Shamba',
            organizations: 'Mashirika',
            country: 'Nchi',
            projectTitle: 'Jina la Mradi',
            registerProject: 'Sajili Mradi Mpya',
            actions: 'Vitendo',
            noData: 'Hakuna watumiaji walipatikana.',
            view: 'Tazama',
            viewLandPermit: 'Tazama Hati ya Ardhi / Ruhusa',
            edit: 'Hariri',
            deactivate: 'Kata',
            deactivateUser: 'Kata Mtumiaji',
            deactivateConfirmation: 'Una uhakika unataka kukata mtumiaji huyu?',
            activate: 'Kufanya Kazi',
            activateUser: 'Kufanya Kazi Mtumiaji',
            activateConfirmation: 'Una uhakika unataka kufanya kazi mtumiaji huyu?',
            deactivatedSuccessfully: 'Mtumiaji ulikatwa kwa mafanikio',
            activatedSuccessfully: 'Mtumiaji ulifanya kazi kwa mafanikio',
            deactivationFailed: 'Hitilafu katika kukata mtumiaji',
            exportAsPdf: 'Hamisha kama PDF',
            projectDetails: 'Maelezo ya Mradi',
            dateJoined: 'Tarehe ya Kujiunga',
            cropGrowingPractice: 'Mazoea ya Kukuza Mazao',
            farm: 'Shamba',
            rejectAll: 'KATA YOTE',
            acceptAll: 'KUBALI YOTE',
            confirmRejectAll: 'Uko karibu kukata maombi ya mashamba yote kujiunga na mradi wa mikopo ya kaboni. Kitendo hiki kitakata kila shamba lililowasilishwa na mkulima katika ombi hili. Una uhakika unataka kuendelea?',
            confirmAcceptAll: 'Uko karibu kukubali maombi ya mashamba yote kujiunga na mradi wa mikopo ya kaboni. Kitendo hiki kitajumuisha kila shamba lililowasilishwa na mkulima katika ombi hili. Una uhakika unataka kuendelea?',
            dateOfRegistration: 'Tarehe ya Usajili',
            farmRegistrationId: 'Kitambulisho cha Usajili wa Shamba',
            dimitraFarmId: 'Kitambulisho cha Shamba la Dimitra',
            notTheFarmer: "Mimi si Mkulima",
            farmerFirstName: 'Jina la Kwanza la Mkulima',
            farmerMiddleName: 'Jina la Kati la Mkulima',
            farmerLastName: 'Jina la Mwisho la Mkulima',
            farmerRegistrationId: 'Kitambulisho cha Usajili wa Mkulima',
            dimitraFarmerId: 'Kitambulisho cha Mkulima wa Dimitra',
            farmGeofence: 'Geofence ya Shamba',
            viewGeofence: 'Tazama Geofence',
            totalFarmSize: 'Ukubwa wa Jumla wa Shamba',
            mainGoals: 'Malengo Yako Makuu ni Nini',
            ownershipType: 'Aina ya Umiliki',
            certifications: 'Udhibitisho',
            productionType: 'Aina ya Uzalishaji',
            landTitle: 'Hati ya Ardhi',
            farmLocationAddress: 'Anwani ya Mahali pa Shamba',
            farmCoordinate: 'Kuratibu ya Shamba',
            farmerAgreement: 'Makubaliano ya Mkulima',
            viewSignedAgreement: 'Tazama makubaliano yaliyotiwa sahihi yaliyowasilishwa na ombi.',
            viewAgreement: 'TAZAMA MAKUBALIANO',
            acceptanceStatus: 'Hali ya Kukubaliwa',
            currentStatus: 'Hali ya Sasa',
            reject: 'KATA',
            accept: 'KUBALI',
            farmActivitySubmissions: 'Wasilisho za Shughuli za Shamba',
            farmActivitySubmissionsDesc: 'Rekodi zilizowasilishwa za mazoea ya kilimo na sasisho zinazohitajika kwa uthibitisho wa mikopo ya kaboni.',
            viewFarmData: 'TAZAMA DATA YA SHAMBA',
            farmData: 'Data ya Shamba',
            farmDataDesc: 'Unda ripoti zako kwa kuunganisha data ya uzalishaji kutoka vyanzo mbalimbali. Chagua chanzo kimoja au zaidi ili kutunga orodha kamili ya mahali pa uzalishaji kwa ripoti zako.',
            crops: 'Mazao',
            sowing: 'Kupanda',
            seedling: 'Mche',
            fertilizer: 'Mbolea',
            fertilizerError: 'Wasilisho lisilo kamili: Maelezo ya mbolea kwa miezi 4 yanakosekana kutoka kwa ingizo la mkulima.',
            harvesting: 'Kuvuna',
            livestock: 'Mifugo',
            equipment: 'Vifaa',
            projectRequests: 'Maombi ya Miradi',
            userNameAndId: 'Jina la Mtumiaji na ID',
            email: 'Barua pepe',
            userRole: 'Mtumiaji',
            status: 'Hali',
            userRegistrationDate: 'Tarehe ya Usajili wa Mtumiaji',
            pending: 'Inasubiri',
            deactivated: 'Iliyokatwa',
            active: 'Inayofanya kazi',
            selectProjectTypeFirst: 'Chagua Aina ya Miradi Kwanza',
            noFarmsToReject: 'Hakuna mashamba ya kukataa',
            allFarmsRejected: 'Mashamba yote yamekataliwa kwa mafanikio',
            rejectAllError: 'Kukata mashamba yote kumeshindwa',
            noFarmsToAccept: 'Hakuna mashamba ya kukubali',
            allFarmsAccepted: 'Mashamba yote yamekubaliwa kwa mafanikio',
            acceptAllError: 'Kukubali mashamba yote kumeshindwa',
            farmNotFound: 'Shamba halijapatikana au halijaunganishwa na mradi',
            farmAlreadyRejected: 'Shamba tayari limekataliwa',
            farmRejected: 'Shamba limekataliwa kwa mafanikio',
            rejectFarmError: 'Kukata shamba kumeshindwa',
            farmAlreadyAccepted: 'Shamba tayari limekubaliwa',
            farmAccepted: 'Shamba limekubaliwa kwa mafanikio',
            acceptFarmError: 'Kukubali shamba kumeshindwa',
        },
    }
}